export default "__VITE_ASSET__CRYpLC4E__"